import {getReportParams, report} from '../../../middleware/report';

export function dwhPageDisplay(pageURL) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Offer';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Offer Page Display';
  reportParams.param3 = pageURL;
  report(reportParams);
}
export function dwhOfferButtonClicked(offerId, pageURL) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Offer';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Offer Button Clicked';
  reportParams.subscriber = '';
  reportParams.param1 = offerId;
  reportParams.param3 = pageURL;
  report(reportParams);
}
